import type { SpellCheckState } from './types';

export const INITIAL_STATE: SpellCheckState = {
  isLoadingSuggestions: false,
  suggestions: [],
};
